<template>
  <b-card no-body class="position-relative">
    <b-card-body
      style="z-index: 10"
      class="d-flex flex-column justify-content-between"
    >
      <div class="d-flex align-items-center flex-wrap">
        <div class="my-25 mr-sm-2 mr-75">
          <b-img
            :src="require(`@/assets/images/fxlegends-new-theme/${info.img}`)"
          />
        </div>
        <div class="truncate pt-50">
          <span>{{ info.description }}</span>
        </div>
      </div>
      <div class="d-flex align-items-center flex-wrap mt-2">
        <b-skeleton class="mb-50" width="120px" height="30px" v-if="loading" />
        <div v-else>
          <span
            class="font-weight-900 h3 mb-0"
            :style="[{ color: info.color }]"
          >
            {{
              info.key == "current_balance"
                ? Number(statistics["current_balance"]).toFixed(2) === "NaN"
                  ? 0
                  : Number(statistics["current_balance"]).toFixed(2)
                : info.key == "total_withdraw"
                ? Number(statistics["total_withdraw"]).toFixed(2) === "NaN"
                  ? 0
                  : (Number(statistics["total_withdraw"]) * -1).toFixed(2)
                : info.key == "total_earnings"
                ? Number(statistics["current_balance"]).toFixed(2) === "NaN"
                  ? 0
                  : Number(statistics["current_balance"]).toFixed(2)
                : Number(statistics["total_deposit"]).toFixed(2) === "NaN"
                ? 0
                : Number(statistics["total_deposit"]).toFixed(2) || "-"
            }}
          </span>
          <feather-icon
            class="font-weight-900 h1"
            icon="DollarSignIcon"
            :style="[{ color: info.color }]"
          />
        </div>
      </div>
    </b-card-body>
    <div
      :class="['position-absolute top-0 left-0 w-100 h-100 ', info.class]"
    ></div>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BImg, BSkeleton } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardBody,
    BImg,
    BSkeleton,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    statistics: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style scoped>
@media (max-width: 576px) {
  .truncate > span {
    font-size: 11px !important;
  }
}
</style>
